import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as BellIcon } from 'images/icons-regular-icons-ic-notifications-none.svg';
import { ReactComponent as ControlIcon } from 'images/icons-regular-icons-ic-chevron-right.svg';
import styles from 'modules/Notifications/components/NotificationHeader/NotificationHeader.module.scss';
import { CSSTransition } from 'react-transition-group';

const NotificationHeader = ({ notificationsCount, onClose }) => {
  return (
    <div className={styles.header}>
      <div className={styles.info}>
        <BellIcon className={styles.bellIcon} />
      </div>
      <div className={styles.title}>
        <h2>Уведомления </h2>
        <CSSTransition
          in={!!notificationsCount}
          timeout={200}
          classNames={styles.animation}
          unmountOnExit
        >
          <span className={styles.label}>{notificationsCount}</span>
        </CSSTransition>
      </div>
      <ControlIcon className={styles.controlIcon} onClick={onClose} />
    </div>
  );
};

NotificationHeader.propTypes = {
  notificationsCount: PropTypes.number,
  onClose: PropTypes.func.isRequired,
};

export default NotificationHeader;
